import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge has to be told about this project's custom scales.
 *
 * Its default heuristic reads `text-*` and decides between font-size and
 * colour by looking at the value: `text-lg` and `text-[13px]` are sizes,
 * anything it does not recognise is assumed to be a colour. So `text-display-md`
 * was being filed as a colour, landing in the same conflict group as
 * `text-tx` — and since the tone class is written second, the size was silently
 * dropped. Section headings rendered at the inherited 16px.
 *
 * Registering the custom values here puts them in the right group. This only
 * extends the default config; every class the rest of the app already relies on
 * behaves exactly as before.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "display-xl",
            "display-lg",
            "display-md",
            "display-sm",
            "lede",
            "eyebrow",
            "label",
            "micro",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
